//@flow
import React from 'react';
import Link from '../../../components/Link';
import OfficeShell from '../../Shell/components/OfficeShell.react';

export default function OfficeThankYou() {
  return (
    <OfficeShell>
      <div className="office-thanks">
        <div className="text-container">
          <h1>Thanks! We&rsquo;ll contact you soon.</h1>
          <p>While you wait, start snacking smarter at home by checking out our online catalog.</p>

          <div className="button-cta">
            <Link to="/"><button className="cta" title="Start shopping">Start shopping</button></Link>
          </div>

        </div>
        <div className="error-footer-banner" />
      </div>
    </OfficeShell>
  );
}
